import React from 'react';
import { useNavigate } from 'react-router-dom';
import SimpleResourceLandingLayout from '../../components/layouts/SimpleResourceLandingLayout';
import columns from './columns';
import { routes, subRoutes } from '../../utils/constants/routes';

const ListAmendments = () => {
  const navigate = useNavigate();

  return (
    <SimpleResourceLandingLayout
      withCreateButton={false}
      resourceName="contracts"
      extraQuery="status=ACTIVE&!exemption&previous_contract"
      populate="insurer"
      columns={columns()}
      editAction={false}
      deleteAction={false}
      onDoubleClickAction={{
        action: (record) =>
          navigate(
            `${routes.CONTRACTS}${subRoutes.CONTRACTS.PORTFOLIO_CONTRACTS}/show/${record?.key}`
          )
      }}
      showAction={{
        pathname: (record) =>
          `${routes.CONTRACTS}${subRoutes.CONTRACTS.PORTFOLIO_CONTRACTS}/show/${record?.key}`
      }}
      scroll={{ x: 1300 }}
    />
  );
};

export default ListAmendments;
